<div class="help-page__header help-page__header--sub-header">
  {{ 'help-page.terms' | translate }}
</div>
<div (click)="closeTerms()" class="icon-close help-page__content--close-button" genericButton></div>
<div class="help-page__content" [innerHTML]="empSpecificContents.terms"></div>
